// extracted by mini-css-extract-plugin
module.exports = {"section":"Third-Section_section__2G-5K","answer":"Third-Section_answer__1omtC","liUpdater":"Third-Section_liUpdater__5W0b0","rotate":"Third-Section_rotate__3GGDx"};